import React, { Component } from 'react';
import { Button, Drawer, Descriptions, Divider, Comment, Row, Col } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import ReactHtmlParser from 'react-html-parser';
import { isMobile } from 'react-device-detect';
import { checkPermission } from '../../utils/permission';
import { isValidDate, processHTML } from '../../utils/helpers';
import ScheduleAreaFunctionForm from './ScheduleAreaFunctionForm';

class ScheduleAreaFunctionDetail extends Component {
    state = { isOpenForm: false };

    close = () => {
        this.props.onCancel();
        this.props.reloadList();
    };

    render() {
        const { visible, currentData } = this.props;
        return (
            <>
                <Drawer
                    visible={visible}
                    title="Chi tiết chức năng khu vực"
                    onClose={this.close}
                    maskClosable={false}
                    width={isMobile ? '100%' : '50%'}
                    extra={checkPermission('schedule_area_functions', 'update') ? (
                        <Button type="primary" icon={<EditOutlined />} onClick={() => this.setState({ isOpenForm: true })}>
                            Sửa
                        </Button>
                    ) : null}
                    footer={<div style={{ textAlign: 'right' }}><Button onClick={this.close}>Đóng</Button></div>}
                >
                    {visible ? (
                        <div>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Khu vực làm việc">{currentData?.area_name}</Descriptions.Item>
                                    </Descriptions>
                                </Col>
                            </Row>
                            <Divider className="no-margin" />
                            <Comment
                                className="comment-content-detail"
                                author={<span className="ant-descriptions-item-label">Mô tả chức năng</span>}
                                content={<div className="chingo-content-detail">{ReactHtmlParser(processHTML(currentData?.description))}</div>}
                            />
                            <Divider className="no-margin" />
                            <Comment
                                className="comment-content-detail"
                                author={<span className="ant-descriptions-item-label">Ghi chú</span>}
                                content={ReactHtmlParser(currentData?.note || '')}
                            />
                            <Divider className="no-margin" />
                            <Descriptions size="small">
                                <Descriptions.Item label="Ngày tạo">
                                    {isValidDate(currentData?.created_at)} bởi {currentData?.created_user}
                                </Descriptions.Item>
                            </Descriptions>
                        </div>
                    ) : null}
                </Drawer>
                <ScheduleAreaFunctionForm
                    visible={this.state.isOpenForm}
                    currentData={currentData}
                    reloadData={this.props.reloadData}
                    onCancel={() => this.setState({ isOpenForm: false })}
                />
            </>
        );
    }
}

export default ScheduleAreaFunctionDetail;
